import React, { useState } from "react";

// core components
import NoResult from "../../configuration/components/noResult";
import TableHeader from "./tableHeader";
import BrandLine from "./brandLine";
import EditDialog from "./editDialog";

export default function EnhancedTableBody (props) {
    const { brands, refreshList, search } = props;

    const [selectedBrand, setSelectedBrand] = useState(null);
    const [isEditOpen, setIsEditOpen] = useState(false);

    const openEdit = (brand) => {
        setSelectedBrand(brand);
        setIsEditOpen(true);
    };

    // Close in two steps: hide the dialog (plays the close animation), then drop the selected brand
    // once the dialog has fully exited. Unmounting the dialog abruptly tears CKEditor down mid-flight
    // ("can't access property destroy, t is null").
    const closeEdit = () => {
        setIsEditOpen(false);
    };

    const onDialogExited = () => {
        setSelectedBrand(null);
    };

    const onUpdated = () => {
        closeEdit();
        refreshList();
    };

    // brands is `null` until the first fetch resolves.
    const filteredBrands = (brands ?? []).filter(
        (brand) => (brand.name ?? "").toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div>
            <TableHeader />
            {/* Extra top gap so the first row sits further from the header, matching /attributes.
                paddingTop (not marginTop) to avoid collapsing with the header's marginBottom. */}
            <div style={{ paddingTop: "8px" }}>
                {filteredBrands.map((brand) => (
                    <div key={brand["@id"]} style={{ marginBottom: "12px" }}>
                        <BrandLine brand={brand} onEdit={openEdit} />
                    </div>
                ))}
            </div>
            {brands !== null && filteredBrands.length === 0 && (
                <NoResult />
            )}
            {selectedBrand && (
                <EditDialog
                    brand={selectedBrand}
                    isOpen={isEditOpen}
                    closeDialog={closeEdit}
                    onExited={onDialogExited}
                    onUpdated={onUpdated}
                />
            )}
        </div>
    );
}
